import React from 'react';
import PropTypes from 'prop-types';
import { IMAGE_NOT_AVAILABLE } from '~/config/constants';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import { useErrorPicture } from '~/hooks/useErrorPicture';
import { addVersionId } from '~/utils/helpers';
import isEmpty from 'lodash/isEmpty';
import { useImageNotAvailable } from '~/hooks/useImageNotAvailable';

function PreviewAsImg({
    pictureUrl,
    width,
    minWidth,
    maxWidth,
    height,
    inputEl,
    heightWrapper,
    id,
    wrapperClass,
    wrapperStyle,
}) {
    const err = useErrorPicture(pictureUrl);
    const img = useImageNotAvailable(pictureUrl);

    return (
        <div
            style={{
                height: heightWrapper ? heightWrapper + 'rem' : 'initial',
                ...wrapperStyle,
            }}
            className={cx(wrapperClass)}
            onClick={() => {
                inputEl.current?.click();
                inputEl.current?.focus(); //need to have focus() here so that on blur event will be fired when clicking away.
            }}
        >
            <img
                src={err ? IMAGE_NOT_AVAILABLE : addVersionId(pictureUrl)}
                style={{
                    width: typeof width === 'string' ? width : width + 'rem',
                    minWidth: typeof minWidth === 'string' ? minWidth : minWidth + 'rem',
                    maxWidth: typeof maxWidth === 'string' ? maxWidth : maxWidth + 'rem',
                    height: typeof height === 'string' ? height : height + 'rem',
                    cursor: isEmpty(inputEl) ? 'initial' : 'pointer',
                    objectFit: 'contain',
                }}
                className={cx({
                    'border border-dark rounded': img === IMAGE_NOT_AVAILABLE || err,
                })}
                id={id}
            />
        </div>
    );
}

PreviewAsImg.defaultProps = {
    width: '',
    height: '',
    minWidth: '',
    maxWidth: '',
    heightWrapper: '',
    id: '',
    pictureName: '',
    wrapperClass: '',
    wrapperStyle: {},
    inputEl: {},
};

PreviewAsImg.propTypes = {
    pictureUrl: PropTypes.string.isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    inputEl: PropTypes.object,
    heightWrapper: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.string,
    wrapperClass: PropTypes.string,
    pictureName: PropTypes.string,
    wrapperStyle: PropTypes.object,
};

export default PreviewAsImg;
